export const SESSION_KEY_PIN_VALUE = "pinValue";
export const SESSION_MAX_AGE_PIN_VALUE = 2700; // Seconds
export const SESSION_KEY_REMEMBER_PIN = "rememberPin";
